module.exports = __webpack_public_path__ + "static/img/item-ydxx.629eaf38.png";